/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as e, isSome as t } from "../../core/maybe.js";
import { createContext as r } from "./context-util.js";
var n;

function o() {
  return n || (n = a()), n;
}

function a() {
  var n = {
    available: !1,
    version: 0,
    majorPerformanceCaveat: !1,
    maxTextureSize: 0,
    supportsHighPrecisionFragment: !1,
    supportsVertexShaderSamplers: !1,
    supportsElementIndexUint: !1,
    supportsStandardDerivatives: !1,
    supportsInstancedArrays: !1,
    supportsTextureFloat: !1,
    supportsColorBufferFloat: !1
  };
  if (void 0 === typeof WebGLRenderingContext) return n;
  var o = document.createElement("canvas");
  if (!o) return n;
  var a = r(o, 1, {
    failIfMajorPerformanceCaveat: !0
  });
  if (e(a) && (a = r(o, 1), t(a) && (n.majorPerformanceCaveat = !0)), e(a)) return n;
  var i = a.getParameter(a.VERSION);
  if (!i) return n;
  var u = i.match(/^WebGL\s+([\d.]*)/);

  if (u) {
    var _e = parseFloat(u[1]);

    n.available = _e >= .94;

    var _t = a.getShaderPrecisionFormat(a.FRAGMENT_SHADER, a.HIGH_FLOAT);

    _t && (n.supportsHighPrecisionFragment = _t.precision > 0), n.supportsVertexShaderSamplers = a.getParameter(a.MAX_VERTEX_TEXTURE_IMAGE_UNITS) > 0, n.supportsElementIndexUint = null !== a.getExtension("OES_element_index_uint"), n.supportsStandardDerivatives = null !== a.getExtension("OES_standard_derivatives"), n.supportsInstancedArrays = null !== a.getExtension("ANGLE_instanced_arrays"), n.supportsTextureFloat = null !== a.getExtension("OES_texture_float"), n.supportsColorBufferFloat = null !== a.getExtension("WEBGL_color_buffer_float") && null !== a.getExtension("EXT_float_blend");
  }

  return n.maxTextureSize = a.getParameter(a.MAX_TEXTURE_SIZE), n.version = s() ? 2 : 1, n;
}

function s() {
  if (void 0 === typeof WebGL2RenderingContext) return !1;
  var e = document.createElement("canvas");
  if (!e) return !1;
  var n = r(e, 2);
  return !!t(n);
}

export { o as default };